import { AfterViewInit, Directive, ElementRef, Input, OnChanges, Renderer2, inject } from "@angular/core";
import { ValidationErrors } from "@shared/validation/models/validation-errros.interface";

@Directive({
   // eslint-disable-next-line @angular-eslint/directive-selector
   selector: "[dynamicValidationsHeight]"
})
export class DynamicValidationsHeightDirective
   implements OnChanges, AfterViewInit {
   private elementRef = inject(ElementRef);
   private renderer = inject(Renderer2);

   private contentElement: HTMLElement;

   @Input() public dynamicValidationsHeight: ValidationErrors;

   public ngOnChanges(): void {
      this.changeContentHeight();
   }

   public ngAfterViewInit(): void {
      this.contentElement = this.elementRef.nativeElement as HTMLElement;
      this.changeContentHeight();
   }

   private changeContentHeight(): void {
      if (
         !this.contentElement ||
         !this.dynamicValidationsHeight?.errors?.length
      ) {
         return;
      }

      const defaultOffset = 216; // 216 is default offset for top and bottom margins of body and modal

      //TODO THIS HAS TO BE RECALCULATED BASED ON ACTUAL HEIGHT OF ERRORS
      const errorLines = Math.ceil(
         this.dynamicValidationsHeight.errors.length / 3
      ); //assuming 3 errors per line
      const errorLinesHeight = errorLines ? errorLines * 20 : 0; // assuming each error line takes approx 20px height
      const errorPaddings = (errorLines - 1) * 12;
      const errorContainerHeight = errorLinesHeight + errorPaddings + 70; //for error lines and error container and other margins

      this.renderer?.setStyle(
         this.contentElement,
         "max-height",
         `calc(100vh - ${defaultOffset + errorContainerHeight}px)`
      );
   }
}
